import { useEffect, useRef, useState, ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLogger } from '../context/useLogger';
import PageLoadingComponent from './PageLoading';

const SESSION_TRANSFER_KEY = 'session_transfer_token';
const STATE_CONNECT_KEY = 'session_transfer_state_connect';

interface SessionTransferHandlerProps {
  children: ReactNode;
}

const SessionTransferHandler = ({ children }: SessionTransferHandlerProps) => {
  const { loginWithRedirect } = useAuth0();
  const logger = useLogger();
  const hasTriggered = useRef(false);
  const [isPending, setIsPending] = useState(
    () => sessionStorage.getItem(SESSION_TRANSFER_KEY) !== null,
  );

  useEffect(() => {
    if (hasTriggered.current) return;

    const sessionTransferToken = sessionStorage.getItem(SESSION_TRANSFER_KEY);

    if (sessionTransferToken) {
      hasTriggered.current = true;
      sessionStorage.removeItem(SESSION_TRANSFER_KEY);

      const stateConnect = sessionStorage.getItem(STATE_CONNECT_KEY);
      sessionStorage.removeItem(STATE_CONNECT_KEY);

      logger.info('Session transfer token detected, redirecting to Auth0');

      void loginWithRedirect({
        authorizationParams: {
          redirect_uri: `${window.location.origin}/callback`,
          session_transfer_token: sessionTransferToken,
        },
        appState: {
          stateConnect: stateConnect || undefined,
        },
      }).catch(error => {
        logger.error('Session transfer login failed:', error);
        setIsPending(false);
      });
    } else {
      setIsPending(false);
    }
  }, [loginWithRedirect, logger]);

  if (isPending) {
    return <PageLoadingComponent />;
  }

  return <>{children}</>;
};

export default SessionTransferHandler;
